import React, { useState } from "react";
import { MorphSvg, MorphSvgProps } from "../../common/MorphSvg";

const HomeMorph: React.FC<MorphSvgProps> = ({ morph, ...props }) => {
  const [open, setOpen] = useState(morph);

  return (
    <MorphSvg
      style={{
        animationDelay: `${Math.random()}s`,
        transitionDelay: `${Math.random() / 2}s`,
      }}
      onClick={() => setOpen(!open)}
      morph={open}
      {...props}
    />
  );
};

export { HomeMorph };
